var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadBatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8800_92298)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4969 2.99377C13.8136 2.83541 14.1864 2.83541 14.5031 2.99377L24.5031 7.99377C24.8842 8.18434 25.125 8.57388 25.125 9C25.125 9.42612 24.8842 9.81566 24.5031 10.0062L14.5031 15.0062C14.1864 15.1646 13.8136 15.1646 13.4969 15.0062L3.49688 10.0062C3.11575 9.81566 2.875 9.42612 2.875 9C2.875 8.57388 3.11575 8.18434 3.49688 7.99377L13.4969 2.99377ZM6.51558 9L14 12.7422L21.4844 9L14 5.25779L6.51558 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99402 18.4969C3.27188 17.9412 3.94764 17.7159 4.50336 17.9938L14.0002 22.7422L23.4971 17.9938C24.0529 17.7159 24.7286 17.9412 25.0065 18.4969C25.2843 19.0526 25.0591 19.7284 24.5034 20.0062L14.5034 25.0062C14.1866 25.1646 13.8138 25.1646 13.4971 25.0062L3.49713 20.0062C2.94141 19.7284 2.71615 19.0526 2.99402 18.4969Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99402 13.4969C3.27188 12.9412 3.94764 12.7159 4.50336 12.9938L14.0002 17.7422L23.4971 12.9938C24.0529 12.7159 24.7286 12.9412 25.0065 13.4969C25.2843 14.0526 25.0591 14.7284 24.5034 15.0062L14.5034 20.0062C14.1866 20.1646 13.8138 20.1646 13.4971 20.0062L3.49713 15.0062C2.94141 14.7284 2.71615 14.0526 2.99402 13.4969Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8800_92298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBatch);
export default __webpack_public_path__ + "static/media/upload-batch.373ccaeb76db5dd4b7225b2e2a3778fa.svg";
export { ForwardRef as ReactComponent };